import React from "react";
import { useCountdownTimer } from "../../../hooks/useCountdownTimer";
import { Box, Card, Stack, Typography } from "@mui/material";
import PortableText from "react-portable-text";

const SaleTimer = ({ content }: { content: any }) => {
  const { time } = useCountdownTimer({
    timeFrom: "2023-06-08T06:30:00.000Z",
    timeUpto: "2024-06-20T06:30:00.000Z",
    slotDuration: 1,
  });
  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={2}>
        {Object.entries(time).map(([k, v]) => {
          if (k === "days") return null;
          return (
            <Card key={k}>
              <Stack
                justifyContent="center"
                alignItems="center"
                sx={{ px: 2, py: 1 }}>
                <Typography
                  component="span"
                  variant="h5"
                  color="error"
                  fontWeight={700}>
                  {v}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {k}
                </Typography>
              </Stack>
            </Card>
          );
        })}
      </Stack>
      <Box
        component={PortableText}
        content={content}
        sx={{
          fontSize: "14px",
          li: {
            ml: 2,
          },
        }}
      />
    </Stack>
  );
};

export default SaleTimer;
